import React from "react";
import ShoppingHero from "./ShoppingHero";
import ShoppingShowcase from "./ShoppingShowcase";
export default function Shopping() {
  return (
    <div className="shopping">
      <ShoppingHero />
      <ShoppingShowcase />
    </div>
  );
}
